<div *ngIf="controlDir" class="flex flex-col gap-2">
  <label *ngIf="label" [for]="identifier" class="truncate text-lg font-bold text-pl-gray-700">{{ label }}</label>

  <div
    class="flex w-full items-center gap-2 rounded-md border-2 border-pl-gray-700 font-sans"
    [ngClass]="isDisabled ? 'pointer-events-none' : 'cursor-pointer'"
    (click)="datepicker.open()"
  >
    <input
      #inputElement
      class="w-full cursor-pointer rounded-md p-2.5 outline-none"
      [id]="identifier"
      [(ngModel)]="value"
      [readOnly]="true"
      [disabled]="isDisabled"
      [min]="minDate"
      [max]="maxDate"
      [matDatepicker]="datepicker"
      (ngModelChange)="onChange()"
      (blur)="onBlur()"
    />

    <pl-icon [name]="PlIcon.calendar_add" class="mr-2.5 h-8 w-8" />
  </div>
  <mat-datepicker [panelClass]="'pl-datepicker-panel'" [color]="" #datepicker></mat-datepicker>
</div>
